import React from 'react';
import { Controller } from 'react-hook-form';
import { observer } from 'mobx-react';
import Select from '@alfa-retail-react/components/select';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { WEB_VISOR_DISABLE, WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { OrderFormValues } from 'app/logic/pages/order/OrderPage';
import { BirthPlaceFormStore } from 'app/logic/pages/order/BirthPlaceFormStore';
import { Reference } from 'app/model/Reference';
import { useIsDesktop } from 'app/utils/useWindowType';
import { ValidationRules } from 'app/form/ValidationRules';

export interface BirthLocalityTypeFormItemProps {
    /**
     * Хранилище состояния, содержадщего информацию о месте рождения пользователя.
     */
    formStore: BirthPlaceFormStore;
}

/**
 * Компонент выбора типа насленного пункта рождения.
 */
export const BirthLocalityTypeFormItem = observer(
    ({ formStore }: BirthLocalityTypeFormItemProps) => {
        const BIRTH_LOCALITY_TYPE_FORM_ITEM = 'birthLocalityType';
        const { control, handleMultipleErrors, setFieldElement } =
            useFormContext<OrderFormValues>();

        const PLACEHOLDER = 'Тип населённого пункта';

        const [isDesktop] = useIsDesktop();

        return (
            <Controller<OrderFormValues>
                control={control}
                defaultValue={formStore.localityTypeCode}
                name={BIRTH_LOCALITY_TYPE_FORM_ITEM}
                rules={{ required: ValidationRules.required() }}
                render={({ field, fieldState }) => {
                    const selected = formStore.localityTypeAsOptionShape(
                        field.value as Reference,
                    );

                    return (
                        <Select
                            className={WEB_VISOR_HIDE}
                            componentRef={(element) => {
                                field.ref(element);
                                setFieldElement(
                                    BIRTH_LOCALITY_TYPE_FORM_ITEM,
                                    element,
                                );
                            }}
                            isDesktop={isDesktop}
                            size="l"
                            options={formStore.localityTypesReference}
                            selected={selected}
                            error={handleMultipleErrors(fieldState.error)}
                            label={PLACEHOLDER}
                            onBlur={field.onBlur}
                            onChange={(event) => {
                                const reference =
                                    formStore.getLocalityTypeByKey(
                                        event.selected.key,
                                    );

                                field.onChange(reference);
                                formStore.setLocalityTypeCode(reference);
                            }}
                        />
                    );
                }}
            />
        );
    },
);
